import React, {useState, useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import {v4 as uuidv4} from 'uuid';
import {useSelector, useDispatch} from 'react-redux';
import {logPageLoadEvents, sendEvarData} from '@ibibo/analytics';
import {useIntersection} from '../../../hooks/useIntersectionObserver';
import {
  redirectToSameWindowWithoutRefresh,
  getCurrentUrlPath,
  getCrid,
} from '../../../../../myaccount/src/utils/redirectWithCrId';
import * as S from './Onboarding.styles';
import TopSection from './TopSection/TopSection';
import WhyMyPartner from './WhyMyPartner/WhyMyPartner';
import PartnerAdvantage from './PartnerAdvantage/PartnerAdvantage';
import MyVideoTestimonial from './VideoTestimonial/VideoTestimonials';
import StartNow from './StartNow/StartNow';
import SafetyAssurance from './SafetyAssurance/SafetyAssurance';
import FooterBlock from './FooterBlock/FooterBlock';
import PopUp from './PopUp/Popup';
import {setAgentDataNew} from '../../../store/actions/thunk';
import {
  tokenSelector,
  userCountrySelector,
  lobSelector,
  userInfoSelector,
} from '../../../store/selectors';
import {HOME_PAGE_URL_NEW, LOGIN_URL_NEW} from '../../../constants';
import {
  setter,
  hasItem,
  getter,
} from '../../../../../../common/client-side-storage/src/client-side-storage.web';
import useViewport from '../../../../../../hooks/use-viewport/use-viewport';
import {useAnalyticService} from '@ibibo/analytics-provider';

const OnboardingNew = ({step, children, showBackButton}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {width} = useViewport();
  const breakpoint = 766;
  const [timeZone, setTimeZone] = useState(false);
  const [showPop, setShowPop] = useState(false);

  const token = useSelector(tokenSelector);
  const userCountry = useSelector(userCountrySelector);
  const lob = useSelector(lobSelector);

  //These are the hooks for the intersection observer for loading the components only when visible
  const [isPartnerAdvantageVisible, setPartnerAdvantageRef] = useIntersection();
  const [isVideoTestimonialVisible, setVideoTestimonialRef] = useIntersection();
  const {updateAnalyticDataStore, sendTrackingDataToSdk} = useAnalyticService();
  const loadPDTTrackingData = () => {
    const pdtTrackingData = {
      global: {
        payload: {
          campaign_details: {
            campaign_name: 'mypartner_direct',
            campaign_key: 'MYPARTNER',
          },
          event_tracking_context: {
            traffic_source: 'mypartner_direct',
            domain_country: 'india',
            domain_currency: 'INR',
            domain_language: 'eng',
            env: 'prod',
            bu: 'mypartner_core',
            organisation: 'MMT',
            funnel_source: 'mypartner_core',
            topic_name: 'mmt_core_mypartner_pdt_client_logging',
            producer: 'mypartner_core',
            template_id: 179775,
          },
          user_context: {
            user_type: null,
            agency_code: null,
            profile_type: 'cta',
            uuid: '',
            is_logged_in: false,
            logging_channel: null,
            wallet_bal: null,
          },
        },
      },
      pageLoad: {
        payload: {
          page_context: {
            lob: 'common',
            lob_category: 'common',
            page_title: null,
            page_name: 'home',
            subpage_name: null,
            site_section: null,
            page_type: 'landing',
            percent_page_viewed: null,
            prev_page_name: null,
            travel_store: null,
            page_url: null,
            funnel_step: 'landing',
            page_state_journey: null,
            sub_lob: 'mypartner_core',
            pg_time_interval: null,
            platform: null,
          },
          coupon_details: null,
          cross_sell_details: null,
          addon_details: null,
          traveller_details_list: null,
          payment_details: null,
          campaign_details: null,
          event_detail: {
            event_name: 'page_entry',
            event_type: 'user_action',
            event_value: 'home',
            components: null,
            client_travel_store_meta: null,
            interaction_type: null,
            booking_info: null,
          },
        },
      },
    };
    if (pdtTrackingData) {
      updateAnalyticDataStore?.(pdtTrackingData, 'HOME');
      sendTrackingDataToSdk?.(pdtTrackingData, 'HOME');
    }
  };

  useEffect(() => {
    if (step >= 1) {
      continueStep();
    }
    if (token) {
      const path = getCurrentUrlPath();
      if (path !== LOGIN_URL_NEW) dispatch(setAgentDataNew(token, successCallback, errorCallback));
    } else if (!token && step > 1) {
      history.push(redirectToSameWindowWithoutRefresh(HOME_PAGE_URL_NEW));

      /*Related to the Business tagging use case
            Covers the case where the agent lands, closes the window, opens it manually without the business reference.
            Whenever user lands on the page and once component mounts, we store the ref, later used when submitting the form*/
    } else if (!token && step === 0) {
      let searchString = new URLSearchParams(location.search);
      if (searchString.has('ref') && !hasItem('ref')) {
        setter('ref', searchString.get('ref'));
      }
      if (searchString.has('cmp')) {
        setter(
          'cmp',
          hasItem('cmp') ? `${getter('cmp')};${searchString.get('cmp')}` : searchString.get('cmp'),
        );
      }
    }
  console.log("GCP CORP AGENTPROXY BUILD");
    logPageLoadEvents('onboarding:signup:landing', {});
    //myPartner_landing_countrySwitch;
    sendEvarData(
      {
        evar15: 'onboarding:signup:landing|mypartner',
        channel: 'onboarding|mypartner',
        prop24: 'onboarding|mypartner',
        evar24: 'onboarding|mypartner',
        prop27: '/agent/home/',
        evar37: userCountry
          ? 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng'
          : 'domain_sbu:mypartner|domain_country:in|domain_currency:inr|domain_language:eng',
        evar54: 'myPartner_onboarding_PasswordMismatch',
      },
      true,
    );
    loadPDTTrackingData();
  }, []);

  useEffect(() => {
    setTimeZone(userCountry);
  }, [userCountry]);

  const continueStep = () => {
    setShowPop(true);
  };

  const editNumber = () => {
    setShowPop(false);
    history.push(`${HOME_PAGE_URL_NEW}?crId=${getCrid('crId') || uuidv4()}`);
  };

  const successCallback = data => {};

  const errorCallback = () => {
    history.push(`${HOME_PAGE_URL_NEW}?crId=${getCrid('crId')}`);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
      /* you can also use 'auto' behaviour
               in place of 'smooth' */
    });
  };
  // if (!width) {
  //   return null;
  // }

  return (
    <S.OnboardingMainWrap id="onboardingnew">
      <TopSection
        displayPop={continueStep}
        timeZone={timeZone}
        showBackButton={showBackButton}
        width={width}
        lob={lob}
      />
      {!timeZone && width > breakpoint && (
        <picture>
          <source
            media="(min-width: 769px)"
            srcSet="https://assets-gos3.goibibo.com/hero_banner-1760089551.png"
          />

          <S.LoyaltyBanner
            src="https://assets-gos3.goibibo.com/hero_banner-1760089551.png"
            alt="loyalty program banner"
          />
        </picture>
      )}
      <WhyMyPartner timeZone={timeZone} />

      <div ref={setPartnerAdvantageRef}>
        {isPartnerAdvantageVisible && <PartnerAdvantage timeZone={timeZone} />}
      </div>

      <div ref={setVideoTestimonialRef}>
        {isVideoTestimonialVisible && !timeZone && (
          <MyVideoTestimonial isMobile={width <= breakpoint} />
        )}
      </div>
      {!timeZone && <StartNow lob={lob} />}
      {/* {!timeZone && <SafetyAssurance />} */}
      <FooterBlock timeZone={timeZone} lob={lob} />
      <PopUp
        step={step}
        showPop={showPop}
        editNumber={editNumber}
        child={children}
        showBackButton={showBackButton}
      />
      <S.BackToTopWrap onClick={scrollToTop} disabled={false}>
        <S.BackToTopInnerWrap>
          <S.BackToTopText>Scroll to Top</S.BackToTopText>
        </S.BackToTopInnerWrap>
      </S.BackToTopWrap>
    </S.OnboardingMainWrap>
  );
};

export default OnboardingNew;
